import ManageListModal from 'components/GlobalModals/ManageListModal/ManageListModal';
import { withManageListModalProps } from 'viewModel/globalModals/manageListModal/withManageListModalProps';

const ConnectedManageListModalProps = withManageListModalProps(ManageListModal);

export default ConnectedManageListModalProps;
